import React, {useEffect, useState, useRef} from "react";
import { alpha, styled } from '@mui/material/styles';
import { Grid, Autocomplete, Box, Typography, TextField, Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person"
import { getData } from "../../../services/library";
import * as api from "../api"

export default function ClientesAutocomplete({
    clientes,
    setClientes,
    dataCliente,
    setDataCliente,
    sucursales,
    clean,
    keyMapRutas,
    setLoadingRemitos,
    setLetra,
    setRemitosCliente,
    setNoHayFcA
}) {
    const [inputValue, setInputValue] = useState();
    const [noOptionText, setNoOptionText]=useState();
    const timeoutRef = useRef(null);

    return (
        <Autocomplete
            disableClearable
            placeholder="Nombre, CUIT o Sisven ID"
            options={clientes ?? []}
            value={dataCliente}
            inputValue={inputValue}
            onChange={(e, value) => {
              clean();
              setDataCliente(value);
              const sitIva = value.situacion_iva;
              api.getLetra(sitIva, setLetra)
              if (value.id_tipocliente === 3) {
                if(!value.facturar_a) {
                    setNoHayFcA(true)
                    return;
                }
                api.getRemitosEnvasado(value.id, value.id_empresa, setLoadingRemitos, setRemitosCliente)
              } else {
                setNoHayFcA(false)
                api.getPedidORemit(keyMapRutas, value, setLoadingRemitos, setRemitosCliente)
              }
            }}
            noOptionsText={noOptionText}
            onInputChange={(e, value, reason) => {
                setInputValue(value);
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }

                if (value?.length >= 2) {
                    timeoutRef.current = setTimeout(() => {
                        getData(`/allClientes/factura-con-remito/${sucursales}/search?query=${encodeURIComponent(value)}`, setClientes)
                        timeoutRef.current = null;
                    }, 300);
                } else {
                    setNoOptionText("Tipee para buscar clientes...");
                    setClientes([]);
                }
            }}
            getOptionLabel={(option) => {
                const razonSoc = option?.razon_social.trim()
                const cuit = option?.cuit?.trim()?.length > 0 ? option?.cuit?.trim()?.replace(/\D/g, '') : "Cuit No Registrado";
                const sisvenId = option?.sisven_id
                const tipo = option?.id_tipocliente === 3 ? "Envasado" : "Granel";
                return (`${razonSoc} (${cuit}) ${sisvenId} - ${tipo}`);
            }}
            isOptionEqualToValue={(option, value) =>
                option?.id === value?.id
            }
            renderOption={(props, option) => {
                const cuit = option?.cuit?.trim()?.length > 0 ? option?.cuit?.trim()?.replace(/\D/g, '') : "Cuit No Registrado";
                const esEnvasado = option?.id_tipocliente === 3;
                return (
                    <Box
                        component="li"
                        {...props}
                        key={option.id}
                        sx={{
                            padding: "12px 16px !important",
                            borderBottom: "1px solid #f1f5f9",
                            transition: "all 0.2s ease",
                            "&:hover": {
                                backgroundColor: "#f1f5f9 !important",
                            },
                            '&[aria-selected="true"]': {
                                backgroundColor: alpha("#164e63", 0.08) + " !important",
                                color: "#164e63",
                                fontWeight: 600,
                            },
                        }}
                    >
                        <PersonIcon sx={{ fontSize: "18px", color: "#475569" }} />
                        {option?.razon_social?.trim()} ({cuit})
                        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <Typography>
                                {option?.sisven_id && (
                                    <Typography
                                        component="span"
                                        sx={{
                                            color: "#475569",
                                            fontSize: "0.85rem",
                                            fontWeight: 400,
                                        }}
                                    >
                                        -Sisven: {option?.sisven_id} - 
                                    </Typography>
                                )}
                            </Typography>
                        </Box>
                        <Chip
                            label={esEnvasado ? "Envasado" : "Granel"}
                            size="small"
                            sx={{
                                height: "20px",
                                fontSize: "0.7rem",
                                fontWeight: 600,
                                backgroundColor: esEnvasado ? alpha("#9333ea", 0.12) : alpha("#164e63", 0.12),
                                color: esEnvasado ? "#9333ea" : "#164e63",
                            }}
                        />
                    </Box>
                )
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    placeholder="Buscar cliente..."
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            backgroundColor: "#ffffff",
                            transition: "all 0.3s ease",
                            "&:hover": {
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#164e63",
                                },
                            },
                            "&.Mui-focused": {
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#164e63",
                                    borderWidth: "2px",
                                },
                            },
                        },
                        "& .MuiInputLabel-root": {
                            color: "#475569",
                            fontWeight: 500,
                            "&.Mui-focused": {
                                color: "#164e63",
                            },
                        },
                    }}
                    InputProps={{
                        ...params.InputProps,
                    }}
                />
            )}
        />
    )
}

